import { createConfirmation } from "react-confirm";
import PaymentDialog from "./PaymentDialog";

export const showPaymentDialog = createConfirmation(PaymentDialog);
